import React from "react";
import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const AuthOptions: React.FC = () => {
  return (
    <div className="min-h-full bg-gray-50 flex items-center justify-center p-4 ">
      <Card className="w-full max-w-xl py-8">
        <CardHeader className="text-center pb-10">
          <CardTitle className="text-7xl font-black text-black mb-4">
            Palette
          </CardTitle>
          <CardDescription className="text-lg text-gray-700 font-semibold">
            Sign Up As A...
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-2">
          <Link to="/stylist-signup" className="block w-full">
            <Button className="w-full bg-black text-white hover:bg-gray-800 h-12 text-lg font-medium">
              Stylists
            </Button>
          </Link>

          <Link to="/distributor-signup" className="block w-full">
            <Button className="w-full bg-black text-white hover:bg-gray-800 h-12 text-lg font-medium">
              Distributors
            </Button>
          </Link>

          <div className="pt-4  flex  gap-2">
            <Link to="/login" className="block w-full">
              <Button 
                variant="outline" 
                className="w-full h-11 text-gray-700 hover:text-black hover:bg-gray-100 text-base font-medium"
              >
                <LogIn size={20} className="mr-2" />
                Log In
              </Button>
            </Link>
            <Link to="/forgot-password" className="block w-full">
              <Button 
                variant="outline" 
                className="w-full h-11 text-gray-700 hover:text-black hover:bg-gray-100 text-base font-medium"
              >
                Forgot Password?
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AuthOptions;